import * as MODULES from '../module-codes'
import axios from 'axios'
import * as Survey from 'survey-vue'
import Vue from 'vue'

// all the data
export const state = {
  surveys: [],
  surveyResponses: [],
  currentSurvey: null,
  currentSurveyIndex: null,
  surveysInProgress: [],
}

// manipulations on existing data
export const getters = {
}

// business logic
export const actions = {
  completeSurvey: ({ commit, dispatch, rootState }, data) => {
    // Get previous survey responses
    axios.post('/api/pcs/get_survey_responses', {
      params: {
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
      },
    }).then((response) => {
      // For first survey response
      if (response.data === "") {
        response.data = [];
      }
      let formerSurveyResponses = response.data
      var title = state.currentSurvey.survey.title
      let survey = new Survey.Model(state.currentSurvey.survey)
      let questions = {}
      survey.getAllQuestions().forEach(question =>  {
        questions[question.name] = question.processedTitle
      });
      formerSurveyResponses.push({
        title: title, 
        index: state.currentSurveyIndex,
        completionTime: new Date().toLocaleString(),
        response: data,
        questions: questions,
      })
      commit('UPDATE_SURVEY_DATA', formerSurveyResponses) 
      // Update Survey Module 
      axios.post('/api/updateModule', {
        params: {
          moduleState: {
            responses: state.surveyResponses,
            inProgress: state.surveysInProgress,
          },
          moduleName: MODULES.SURVEY,
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      }).then(() => {
        // If there is an event to trigger after survey is taken
        if (state.currentSurvey.eventToTrigger !== undefined) {
          dispatch("events/processEvent", { eventId: state.currentSurvey.eventToTrigger }, { root: true });
        }
      })
      if (data["Role Ranking"]) {
        let userRoles = [];
        data["Role Ranking"].forEach((role, index) => {
          if (data[`explanation ${index + 1}`]){
            userRoles.push({ name: role, explanation: data[`explanation ${index + 1}`] })
          }
          else {
            userRoles.push({ name: role })
          }
        })
        // Flip order for storage (algorithm prefers higher numbers)
        let rolesOrder = userRoles.reverse();
        axios.post('/api/pcs/roles', {
          params: {
            pcs: localStorage.getItem('pcs')
          }
        }).then(response => {
          let fullSettings = response.data['settings']
          let roles = response.data['settings'].roles
          rolesOrder.forEach((userRole, index) => {
            let currentRole = roles.find(role => {
              return (role.name === userRole.name)
            })
            currentRole.rank = index + 1
            currentRole.explanation = userRole.explanation
          })
          fullSettings.roles = roles;
          // Send Roles to database
          axios.post('/api/updateModule', {
            params: {
              moduleState: fullSettings,
              moduleName: MODULES.ROLES,
              pcs: localStorage.getItem('pcs'),
              classId: rootState.auth.classId,
            },
          })
        })
      }
    })
  },
  saveSurveyProgress: ({ commit, rootState }, data) => {
    commit('SET_SURVEY_IN_PROGRESS', data)
    axios.post('/api/updateModule', {
      params: {
        moduleState: {
          responses: state.surveyResponses,
          inProgress: state.surveysInProgress,
        },
        moduleName: MODULES.SURVEY,
        pcs: localStorage.getItem('pcs'),
        classId: rootState.auth.classId,
      },
    })
  },
  populateFromDB: ({ commit, dispatch }, payload) => {
    axios.post('/api/pcs/survey', {
      params: {
        pcs: localStorage.getItem('pcs')
      }
    })
      .then(response => {
        let settings = response.data['settings'] // {'surveys': ["survey":{{"pages":{'name': 'name', 'type': 'text'}]}}
        let json = settings.surveys
        commit('SET_SURVEYS', json)
        
        if (payload) {
          commit('SET_SURVEY_USER_CONTENT', payload)
        }
      })
  },
  setCurrentSurvey: ({ commit }, data) => {
    commit('SET_CURRENT_SURVEY', data)
  },
}

// how we modify the data
export const mutations = {
  SET_SURVEYS: (state, json) => {
    state.surveys = json
  },
  SET_SURVEY_USER_CONTENT: (state, data) => {
    state.surveyResponses = data.responses
    if (data.inProgress) {
      state.surveysInProgress = data.inProgress
    }
    else {
      state.surveysInProgress = []
      state.surveys.forEach(() => {
        state.surveysInProgress.push(false)
      })
    }
  },
  UPDATE_SURVEY_DATA: (state, data) => {
    state.surveyResponses = data
    Vue.set(state.surveysInProgress, state.currentSurveyIndex, false)
  },
  SET_CURRENT_SURVEY: (state, data) => {
    state.currentSurveyIndex = data
    state.currentSurvey = state.surveys[data];
  },
  SET_SURVEY_IN_PROGRESS: (state, data) => {
    state.surveysInProgress[state.currentSurveyIndex] = data
  }
}
